import(/* webpackMode: "eager" */ "/home/circleci/project/packages/next_public/src/app/error.tsx");
